import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBestImagesGroup } from '../../api/fetch-best-images-group';

export const fetchBestImagesGroupThunk = createAsyncThunk(
    'fetchBestImagesGroup',
    async () => fetchBestImagesGroup(),
);
